import { useRef } from "react";
import { useOkapiKy, useStripes } from "@folio/stripes/core";
import { okapiKyKey } from "../utils/okapiKyKey";
/**
 * Referentially stable variant of stripes-core `useOkapiKy`.
 *
 * `useOkapiKy` calls `ky.create(...)` on every render, so an effect, memo or
 * callback that lists the instance in its dependencies reruns on every render.
 * This hook keeps returning the same instance for as long as the okapi settings
 * it is built from (url, tenant, token, locale, timeout) stay the same, and
 * switches to a fresh one as soon as any of them changes.
 *
 * Use it wherever a ky instance feeds an effect / memo / callback dependency.
 */
export var useStableOkapiKy = function (options) {
    var freshInstance = useOkapiKy(options);
    var key = okapiKyKey(useStripes().okapi, options === null || options === void 0 ? void 0 : options.tenant);
    var cacheRef = useRef(null);
    if (cacheRef.current === null || cacheRef.current.key !== key) {
        cacheRef.current = { key: key, instance: freshInstance };
    }
    return cacheRef.current.instance;
};
